import React from 'react';
import IWhitePaper from './IWhitePaper';
import { classNames } from '@features/utils/reactFunctions';
import * as style from './WhitePaperStyle.module.scss'

const WhitePaper: React.FunctionComponent<IWhitePaper> = (props) => {

  const renderHeadline = () => {
    if (props.headline) {
      if (typeof props.headline === 'string') {
        return <h2 className={style.headline}>{props.headline}</h2>;
      }

      return props.headline;
    }

    return undefined;
  };

  return (
    <div className={classNames(style.whitePaper, props.className)}>
      {renderHeadline()}
      <div>{props.children}</div>
    </div>
  );
};

export default WhitePaper;
